<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
  >
    <template #label>
      <slot name="label" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #body>
      <fieldset>
        <template v-for="(option, i) in options">
          <label
            :key="i"
            v-tooltip="{ content: option.description}"
            class="pega-input"
            :class="labelClassName"
          >
            <input
              :data-test="'option-' + i"
              :type="type"
              :value="option.id"
              :class="className"
              :name="name"
              :checked="value.includes(option.id)"
              :disabled="disabled"
              @change="update"
            ><span :class="valueClassName">
              {{ option.name }}
            </span>
          </label>
        </template>
      </fieldset>
      <div v-if="mailFlag">
        <div
          data-test="mail-text"
        >
          ※メール受信設定は、各アカウントで設定・変更できます。詳細は
          <a
            class="mailGuide"
            data-test="guide-link"
            :href="`/help/faq/index_287.html`"
            target="_blank"
          >
            こちら
          </a>
          をご参照ください。
        </div>
      </div>
    </template>
    <template #error>
      <slot name="error" />
    </template>
  </form-label>
</template>

<style scoped>
input {
  cursor: pointer;
}
.mailGuide {
  text-decoration: underline !important;
}
</style>

<script>
import FormLabel from '@/components/atoms/FormLabel'

export default {
  components: {
    FormLabel
  },
  props: {
    type: {
      type: String,
      default: 'checkbox'
    },
    label: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    labelClassName: {
      type: String,
      default: ''
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    valueClassName: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      default: 'form-item-group'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mailFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      values: this.value
    }
  },
  watch: {
    value (val) {
      this.$set(this, 'values', val)
    }
  },
  methods: {
    update (e) {
      if (this.type === 'checkbox') {
        if (e.target.checked) {
          this.values.push(Number(e.target.value))
        } else {
          this.values = this.values.filter(v => v !== Number(e.target.value))
        }
        this.$emit('input', this.values)
        this.$emit('change', this.values)
      } else {
        this.$emit('input', e.target.value)
        this.$emit('change', e.target.value)
      }
    }
  }
}
</script>
